"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutAnchorObjectFinder = void 0;
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var LayoutAnchorObjectFinder = (function () {
    function LayoutAnchorObjectFinder(layout, pos, subDocId, findOnlyOnPage) {
        var pageIndex;
        var pageIndexEnd;
        if (findOnlyOnPage === undefined) {
            pageIndex = 0;
            pageIndexEnd = layout.validPageCount;
        }
        else {
            pageIndex = findOnlyOnPage;
            pageIndexEnd = Math.min(findOnlyOnPage + 1, layout.validPageCount);
        }
        for (var page = void 0; (page = layout.pages[pageIndex]) && pageIndex < pageIndexEnd; pageIndex++) {
            var obj = number_1.NumberMapUtils.elementBy(page.anchoredObjectHolder.objects, function (obj) {
                return layout.anchorObjectsPositionInfo.getPosition(obj.objectId) == pos && obj.belongsToSubDocId === subDocId;
            });
            if (obj) {
                this.page = page;
                this.obj = obj;
                return;
            }
        }
    }
    return LayoutAnchorObjectFinder;
}());
exports.LayoutAnchorObjectFinder = LayoutAnchorObjectFinder;
